import { useState } from 'react';
import { liveReports } from '@/mocks/hotNews';

const bodies: Record<string, string[]> = {
  l1: ['整场发布会进行到公布定价环节时，现场气氛一度凝固。我们记录下主理人在记者会上被追问“性价比”时的原话，以及他围绕研发成本给出的详细拆解。', '随后记者接连抛出关于供货、配色与售后的问题，主理人逐一回应。会后多名行业观察人士在现场接受采访时，看法并不一致。'],
  l2: ['散场已过午夜，仍有大批观众留在场馆外不愿离开。她们用提前准备好的灯牌，在夜空中拼出一整面巨型应援墙，场面持续了约四十分钟。', '我们对多位蹲守的观众做了简短采访，有人说是为了“陪偶像走完最后一程”，也有人只是被现场情绪感染。场馆工作人员在旁疏导，秩序总体良好。'],
  l3: ['开业倒计时前，门口已排出数百人的长队。随着卷帘门升起，队伍迅速涌向柜台，热门单品在90分钟内宣告售罄。', '门口依然有人在等补货，黄牛与代购在队伍中穿梭叫卖。店主在午间发了一条致歉声明，称将于明日增加备货量，并向排队的顾客致谢。'],
};

export default function LiveReports() {
  const [active, setActive] = useState<string | null>(null);

  return (
    <section id="live" className="w-full scroll-mt-24 bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
              <i className="ri-camera-lens-fill" aria-hidden="true" /> ON-SITE
            </p>
            <h2 className="mt-2 font-display text-2xl font-black md:text-3xl">现场直击 · 第一现场实拍还原</h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">编辑与特约观察员蹲守一线，用时间线逐段还原热点现场的真实经过。</p>
          </div>
          <a href="#feed" className="flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800">
            更多速报 <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </div>

        <div className="mt-7 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {liveReports.map((r) => {
            const expanded = active === r.id;
            return (
              <article key={r.id} className="flex flex-col overflow-hidden rounded-2xl bg-background-100">
                <div className="relative aspect-[3/2] w-full overflow-hidden">
                  <img src={r.image} alt={r.title} className="h-full w-full object-cover object-top transition-transform duration-300 hover:scale-105" />
                  <span className="absolute left-3 top-3 flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50">
                    <i className="ri-record-circle-line" aria-hidden="true" /> {r.tag}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4 md:p-5">
                  <h3 className="font-display text-base font-bold leading-6 text-foreground-950 md:text-lg">{r.title}</h3>
                  <p className="mt-2 text-sm leading-6 text-foreground-600">{r.summary}</p>
                  {expanded && (
                    <div className="mt-3 space-y-2 border-l-2 border-accent-300 pl-3">
                      {bodies[r.id].map((t, i) => (
                        <p key={i} className="text-sm leading-6 text-foreground-700">{t}</p>
                      ))}
                    </div>
                  )}
                  <div className="mt-auto flex items-center justify-between pt-4">
                    <div className="flex items-center gap-3 text-xs text-foreground-500">
                      <span className="flex items-center gap-1"><i className="ri-time-line" aria-hidden="true" />{r.time}</span>
                      <span className="flex items-center gap-1"><i className="ri-eye-line" aria-hidden="true" />{r.views}</span>
                    </div>
                    <button type="button" onClick={() => setActive(expanded ? null : r.id)} className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-600 hover:text-primary-800">
                      {expanded ? '收起实况' : '展开实况'} <i className={`transition-transform ${expanded ? 'rotate-180' : ''} ri-arrow-down-s-line`} />
                    </button>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}